import { useState } from 'react';
import {
  Breadcrumbs as MuiBreadCrumb,
  StyledEngineProvider,
} from '@mui/material';
import { navigateTo } from 'utilities/Utils';
import Typography from '../Typegraphy/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNextRounded';
import MuiLink from '@mui/material/Link';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  rootLink: {
    color: '#404040',
    cursor: 'not-allowed',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  root: {
    '& [class*="MuiBreadcrumbs-separator"]': {
      marginLeft: '1px',
      marginRight: '5px',
    },

    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  link: {
    color: '#0B61D9',
  },
}));

type PathOptionsType = {
  label: string | number;
  url?: string;
  disabled?: boolean;
};

type PathArrTypes = Array<PathOptionsType>;

type BreadcrumbProps = {
  pathArr: PathArrTypes;
  handleChange?: ({ val, index }: { val: PathArrTypes; index: number }) => void;
};

const useBreadCrumbState = (
  arr: PathArrTypes,
  callback: (val: PathOptionsType, pathArr: PathArrTypes) => void,
) => {
  const [pathArr, setPathArr] = useState(arr);

  const handleChange = ({ val, index }) => {
    setPathArr(pathArr.slice(0, index + 1));
    callback(val, pathArr);
  };

  const addFragments = arr => {
    setPathArr([...pathArr, ...arr]);
  };

  return {
    pathArr,
    addFragments,
    handleChange,
  };
};

function Breadcrumbs(props: BreadcrumbProps) {
  const { pathArr, handleChange } = props;
  const classes = useStyles();

  const handleChangeInternal = ({ val, index }) => {
    if (val.url) {
      navigateTo(val.url);
    }
    handleChange?.({ val, index });
  };

  if (!pathArr.length) return null;
  const slicedArr = pathArr.slice(0, -1);

  return (
    <StyledEngineProvider injectFirst>
      <MuiBreadCrumb
        separator={<NavigateNextIcon fontSize="medium" />}
        aria-label="breadcrumb"
        className={classes.root}
      >
        {slicedArr.map((val, index) => (
          <MuiLink
            key={index}
            component="button"
            disabled={val.disabled}
            className={`${
              val.disabled ? classes.rootLink : classes.link
            } flex text-size-12`}
            onClick={handleChangeInternal.bind(null, { val, index })}
            underline="hover"
          >
            {val.label}
          </MuiLink>
        ))}
        <Typography
          themeColor="text.primary"
          variant="subtitle1"
          className="fmed"
        >
          {pathArr[pathArr.length - 1].label}
        </Typography>
      </MuiBreadCrumb>
    </StyledEngineProvider>
  );
}

export { Breadcrumbs, useBreadCrumbState };
